export const PERMISSION_ORDER = ["view", "create", "update", "delete"];
